export const getPercentage = (product, memberPrice) => {
  let divided = 0;
  if (memberPrice) {
    divided = product?.memberPrice?.incVat / product?.previousPrice?.incVat;
  } else {
    divided = product?.price?.incVat / product?.previousPrice?.incVat;
  }
  const fixed = divided.toFixed(2);
  const fixedPercentage = Math.floor((1 - fixed) * 100);

  // Smart rounding: if within 1 point of a multiple of 5 or 10, round to the nearest
  const smartRound = (percentage) => {
    // Check if we're within 1 point of a multiple of 5
    const remainder5 = percentage % 5;
    if (remainder5 === 4) {
      return percentage + 1; // Round up to next multiple of 5
    }
    if (remainder5 === 1) {
      return percentage - 1; // Round down to previous multiple of 5
    }

    // Check if we're within 1 point of a multiple of 10
    const remainder10 = percentage % 10;
    if (remainder10 === 9) {
      return percentage + 1; // Round up to next multiple of 10
    }
    if (remainder10 === 1) {
      return percentage - 1; // Round down to previous multiple of 10
    }

    return percentage; // No smart rounding needed
  };

  return smartRound(fixedPercentage);
};